import PropTypes from "prop-types"
import React, { useContext, useState } from "react"
import logo from "../../assets/logo-cropped.svg"
import MailIcon from "../../assets/icons/chatBubble.svg"
import SearchInputServiceLocations from "../SearchInput/SearchInputServiceLocations"
import { useSelector } from "react-redux"
import { Link, navigate } from "gatsby"
import "./style.scss"
import InboxLink from "../inboxLink/inboxLink"
import { MdOutlineMenu, MdOutlineMenuOpen } from "react-icons/md"
import Button from "../button/Button"
import { useLocation } from "@reach/router"
import { FaUser } from "react-icons/all"
import { LayoutContext } from "../layout" // Import the context

const Header = () => {
  const [openMobileToggle, setOpenMobileToggle] = useState(false)
  const user = useSelector(state => state.user.data)
  const pathname = typeof window !== "undefined" ? window.location.pathname : ""
  const newBookingStatus = useSelector(state => state.booking.newBookingStatus)
  const location = useLocation()
  const { navRef } = useContext(LayoutContext) // Get the navRef from context

  // check if the current path contains "payment-checkout"
  const isOnPaymentCheckoutRoute = location.pathname.includes(
    "payment-checkout"
  )

  const handleCloseMenu = () => {
    setOpenMobileToggle(false)
  }
  //if booking request in progress disable the nav bar
  if (pathname.includes("/create-new/") || isOnPaymentCheckoutRoute) {
    return (
      <header id="header">
        <nav className="navbar navbar-expand-lg" ref={navRef}>
          <div className="container">
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                width: "100%",
              }}
            >
              <Link className="navbar-logo" to="/">
                <img src={logo} alt="logo" />
              </Link>
            </div>
          </div>
        </nav>
      </header>
    )
  }

  //default header
  return (
    <header id="header">
      <nav className="navbar navbar-expand-lg" ref={navRef}>
        <div className="container">
          <div className="d-flex align-items-center">
            <Link className="navbar-logo" to="/" onClick={handleCloseMenu}>
              <img src={logo} alt="logo" />
            </Link>
            {user && (
              <span className={"invisible-in-desktop"}>
                <InboxLink
                  navLink={true}
                  handleClick={handleCloseMenu}
                  icon={
                    <img
                      src={MailIcon}
                      alt="inbox icon"
                      width={25}
                      height={25}
                    />
                  }
                />
              </span>
            )}
            <button
              onClick={() => setOpenMobileToggle(!openMobileToggle)}
              className="navbar-toggler invisible-in-mobile"
              type="button"
              data-toggle="collapse"
              data-target="#navbarNavDropdown"
              aria-controls="navbarNavDropdown"
              aria-expanded={openMobileToggle}
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon">
                {openMobileToggle ? <MdOutlineMenu /> : <MdOutlineMenuOpen />}
              </span>
            </button>
            <div
              className={`collapse navbar-collapse ${
                openMobileToggle ? "open" : ""
              }`}
              id="navbarNavDropdown"
            >
              <ul className="navbar-nav ml-auto">
                <li className="navbar__item invisible-in-small-mobile">
                  <div
                    className={
                      pathname !== "/"
                        ? "nav-search nav-search__show"
                        : "nav-search nav-search__hide"
                    }
                  >
                    <SearchInputServiceLocations />
                  </div>
                </li>
                {user ? (
                  <li className="navbar__item">
                    <InboxLink navLink={true} handleClick={handleCloseMenu} />
                  </li>
                ) : (
                  <li className="navbar__item">
                    <Link
                      className="nav-link"
                      to="/login"
                      onClick={handleCloseMenu}
                    >
                      Login
                    </Link>
                  </li>
                )}
                <li className="navbar__item">
                  <Link
                    className="nav-link"
                    to="/partner-with-us"
                    onClick={handleCloseMenu}
                  >
                    Add a boat
                  </Link>
                </li>
                <li className="navbar__item">
                  <Link
                    className="nav-link"
                    to="/faq"
                    onClick={handleCloseMenu}
                  >
                    Help
                  </Link>
                </li>
                <li className="navbar__item">
                  <Link
                    className="nav-link"
                    to="/contact"
                    onClick={handleCloseMenu}
                  >
                    Contact
                  </Link>
                </li>
                {user && (
                  <UserProfileLink
                    lastName={user?.lastName}
                    firstName={user.firstName}
                    handleCloseMenu={handleCloseMenu}
                  />
                )}
                {!user && (
                  <li className="navbar__item navbar__signupLink">
                    <Link
                      className="nav-link"
                      to={`/signup`}
                      onClick={handleCloseMenu}
                    >
                      Sign up
                    </Link>
                  </li>
                )}
                {!user && (
                  <li className="navbar__item navbar__signupButton">
                    <Button
                      label={"Sign up"}
                      loading={false}
                      onPress={() => {
                        handleCloseMenu()
                        navigate(`/signup`)
                      }}
                    />
                  </li>
                )}
              </ul>
            </div>
          </div>
          <div>
            <button
              onClick={() => setOpenMobileToggle(!openMobileToggle)}
              className="navbar-toggler invisible-in-desktop"
              type="button"
              data-toggle="collapse"
              data-target="#navbarNavDropdown"
              aria-controls="navbarNavDropdown"
              aria-expanded={openMobileToggle}
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon">
                {openMobileToggle ? <MdOutlineMenuOpen /> : <MdOutlineMenu />}
              </span>
            </button>
          </div>
        </div>
      </nav>
    </header>
  )
}

const UserProfileLink = ({ firstName, lastName, handleCloseMenu }) => {
  return (
    <>
      {firstName && lastName && (
        <li className="navbar__item">
          <Link
            className="nav-link"
            to={`/profile/update/`}
            onClick={handleCloseMenu}
          >
            <FaUser />{" "}
            <span>
              {firstName?.charAt(0)?.toUpperCase()}
              {lastName?.charAt(0)?.toUpperCase()}
            </span>
          </Link>
        </li>
      )}
    </>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
